import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
// middlewares
// import AuthMiddleware from '../../../../reducers/auth/middleware';
import { Navigate } from 'react-router-dom';
import CityMiddleware from '../../../../middleware/modules/master/city';
import City from '../../../../components/modules/master/city';
import useScript from '../../../../components/utilities/useScript';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';

const mapStateToProps = ({ auth,city }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  datalist:city.data
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    CityList: customer =>CityMiddleware.list(customer)
  }, dispatch);
};
class CityContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.object,
    datalist: PropTypes.object,
    CityList: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: {}
  }
  componentWillMount() {
    var host=process.env.APP_URL
    const search = {
      limit: 10,
    };
   this.props.CityList(search);
  }
  render() {
    const { isAuthenticated, isProcessing, isRegistered, isError, errorMessage, CityList ,datalist} = this.props;
   
    return (
      <City 
        search={CityList}
        data={datalist}
        isProcessing={isProcessing}
        isError={isError}
        errorMessage={errorMessage}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CityContainer);
